module.exports = __webpack_public_path__ + "b85eac5e8ac8eed6fc780797b3c57fc1.pdf";